import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './update-task-repeat-timeslot.style';

export type DeleteHabitMessageProps = {
  onSingle: () => void;
  onAll: () => void;
  onCancel: () => void;
};

export const UpdateTaskRepeatTimeslotMessage: React.FC<
  DeleteHabitMessageProps
> = ({ onSingle, onAll, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('forms.update-habit-repeating-timeslot.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('forms.update-habit-repeating-timeslot.description')}
        </Typography>
      </Styled.Body>

      <Styled.Footer>
        <Button variant={Variants.Text} size={Sizes.Medium} onClick={onCancel}>
          {t('forms.update-habit-repeating-timeslot.buttons.cancel.label')}
        </Button>

        <Styled.Interactions>
          <Button
            variant={Variants.Outlined}
            size={Sizes.Medium}
            onClick={onSingle}
          >
            {t('forms.update-habit-repeating-timeslot.buttons.single.label')}
          </Button>
          <Button size={Sizes.Medium} color={Colors.Primary} onClick={onAll}>
            {t('forms.update-habit-repeating-timeslot.buttons.all.label')}
          </Button>
        </Styled.Interactions>
      </Styled.Footer>
    </>
  );
};
